export default class NetworkHandler {


    constructor(_assistant,_httpHandler, config, httpServerId = 1) {
        this._assistant = _assistant;
        this._httpHandler = _httpHandler
        this.config = config;
        this.threadRequest = config.threadRequest || false;

        this.websocket = null;

        this.queue = [];
        this.requesting = false
        this.websocketConnected = false
        this.websocketConnecting = false
        this.onHttpResponse = null
        this.onHttpError = null
        this.onSocketOpen = null
        this.onSocketClose = null
        this.onSocketMessage = null
        this.onSocketError = null
        this.connectSocket = null
    }

    set httpHandler(__httpHandler) {
        this._httpHandler = __httpHandler;
    }

    set httpServerId(_httpServerId) {
        this._httpServerId = _httpServerId;
    }


    sendHttpMessage(key, data, isFull,first) {
        return this.doHttpSend(key, data,isFull, first)
    }

    connectSocket(para, serverId) {
        this.doWebsocketConnect(para, serverId)
    }

    //
    finishAndCheck() {
        if(!this.threadRequest)return;//如果不是线性请求，无需操作
        this.requesting = false
        this.currentCaller = null
        this.check();
    }

    check() {
        console.debug('check request',this.queue.length);
        var para = this.queue.shift();
        if (!para)
            return;
        if (para.type === 0)
            this.doHttpSend(para.key, para.data, false, para.caller,para.timeoutValue,para.requestId);
        else
            this.doWebsocketConnect(para.para, para.serverId)


    }


    deleteHttpMessage(caller) {
        console.debug('wasteRequest');

        if (this.callerMap.get(caller) == undefined) return
        let keys = this.callerMap.get(caller).keys
        Array.isArray(keys) ? keys : keys = [keys]
        let index = keys.indexOf(this.sendingKey)
        if (this.callerMap.get(caller).requestId) {
            this.wasteRequest.push(this.callerMap.get(caller).requestId)
        }
        for (var i = 0; i < this.queue.length; i++) {
            if (keys.indexOf(this.queue[i].key) != -1 && this.queue[i].caller == caller) {
                this.queue.splice(i, 1)
                i--
            }
        }
        this.callerMap.delete(caller)
        this.finishAndCheck()
    }

    doHttpSend(key, data, isFull,first,promisePara) {

        //this.queue.push({key:'asdads'})
        // console.info('requestKey====', key);
        var {promise,resolve,reject} = promisePara || {};
        promisePara || ( promise = new Promise((res,rej)=>(resolve=res,reject=rej)) );

        if (this.threadRequest && this.requesting) {
            !first ? this.queue.push({key, data, timeoutValue,type: 0,requestId,promise:{promise,resolve,reject}})
                : this.queue.unshift({key, data,timeoutValue, type: 0,requestId,promise:{promise,resolve,reject}})
            console.info('doHttpSend====积攒的长度======', this.queue.length);
            return promise;
        }
        var itemConfig = this.config.httpMessages[key];
        if (!itemConfig) {
            console.error('request key cant be found in configs:::', key);
            reject(new Error('request key cant be found in configs'));
            this.finishAndCheck();
            return promise;
        }
        if (itemConfig.needSocket && !this.websocketConnected) {
            console.info('request key need after need:::', key);
            !first ? this.queue.push({key, data, type: 0,promise:{promise,resolve,reject}})
                : this.queue.unshift({key, data, caller, type: 0,promise:{promise,resolve,reject}})
            this.connectSocket && this.connectSocket.call()
            return;
        }
        this.threadRequest && ( this.requesting = true );

        var itUrl = itemConfig.url;
        // data && this._checkSum != null && (data.checksum = this._checkSum)
        // data && this._token != null && (data.token = this._token)
        // if( itemConfig.method === 'get' && data )
        // 	Object.keys(data).map((k,i)=>itUrl+=((i>0?'&':'?')+encodeURI(k)+'='+encodeURI(data[k])))

        var url = itemConfig.isupload && this.config.uploadBaseUrl ||this.config.httpBaseUrl(itemConfig) + itUrl;

        //不是上传文件 才处理 data
        //上传文件要作单独的处理
        // !itemConfig.isupload && this.beforeHttpSend && ( data = this.beforeHttpSend(data) );

        //如果是上传文件，设置headers
        var headers=itemConfig.isupload && {
                'Content-Type': 'multipart/form-data'
            } || null;

        this._httpHandler[itemConfig.method](url
            , data
            , (response) => this.httpReponse({promise,resolve,reject},key, data, response, isFull)
            , (error) => this.httpError({promise,resolve,reject},key, data, error)
	        ,headers
            , (error)=>this.httpRequestTimeout({promise,resolve,reject},key,data,error)
            ,itemConfig.timeout ||3000//有待传入
            ,null
        );
        return promise;
    }

    doWebsocketConnectByUrl(url) {

        console.debug('=====do socketurl=====', url)
        if (this.websocketConnected) return
        let timestamp = new Date().getTime()
        let sign = md5(timestamp + this.config.socketPassWord);
        url += '?time=' + timestamp + '&sign=' + sign
        this.websocket = new WebSocket(url)
        this.websocket.onopen = evt => this.websocketOpen(evt);
        this.websocket.onclose = evt => this.websocketClose(evt);
        this.websocket.onmessage = evt => this.websocketMessage(evt);
        this.websocket.onerror = evt => this.websocketError(evt);


    }

    doWebsocketConnect(para, serverId, atFirst = false) {



        console.debug('=====this.websocketConnected=====', para)

        if (this.requesting) {
            !atFirst ? this.queue.push({para, serverId, type: 1}) : this.queue.unshift({para, serverId, type: 1})
            return;
        }
        this.requesting = true;
        var itUrl = '';
        // var url = 'ws://'+"10.0.0.10:8090"
        var url = 'ws://' + para.url
        if (para.data) {
            para = para.data
            Object.keys(para).map((k, i) => itUrl += ((i > 0 ? '&' : '?') + encodeURI(k) + '=' + encodeURI(para[k])))
        }
        // var url = 'ws://10.0.0.249:8090';
        var urlParas = [serverId]
        urlParas.map((v, index) => {
            url = url.replace(new RegExp("\\{" + index + "\\}", 'gi'), urlParas[index])
        })
        url += itUrl;

        // var url = this.config.websocketBaseUrl;
        // var url = '10.0.0.9:8090';
        console.debug('=====do socketurl=====', url)
        this.websocket = new WebSocket(url)
        var handler = this;
        this.websocket.onopen = evt => this.websocketOpen(evt);
        this.websocket.onclose = evt => this.websocketClose(evt);
        this.websocket.onmessage = evt => this.websocketMessage(evt);
        this.websocket.onerror = evt => this.websocketError(evt);
    }

    // error callback

    httpReponse(promisePara,key, requestData, response, isFull) {
        var {promise,resolve,reject} = promisePara;
        try {
            var itemConfig = this.config.httpMessages[key]
            var fullData = response.data
            /// response.data 有可能是空字符串按照道理讲 应该不会这样的  ...后端可能是有问题的(在这里加一个容错的判断 !response.data)
            if (response.data && itemConfig.responseType === 'json' && typeof fullData === 'string') {
                response.data = JSON.parse(fullData)
                fullData = JSON.parse(fullData)
            }
            var data = this.config.onHttpResponse && this.config.onHttpResponse.call(this._assistant,key, response.data, requestData, response,fullData) || response.data;
            ( isFull || itemConfig.responseFull ) && ( data = fullData );
            resolve( data );
            // this.onHttpResponse && ( response.data = this.onHttpResponse(key, response.data, requestData, response, fullData) );

            // this.dispatch(key, response.data, requestData, response, fullData)


        } catch (e) {
            console.debug('httpReponse error info', e)
            reject(e);
            // alert('请求正常返回,但是处理请求的时候报错:'+key);
        } finally {
            this.finishAndCheck()
        }


    }

    httpError(promisePara,key, requestData, response, requestId) {
        var {promise,resolve,reject} = promisePara;
        try{
            this.config.onHttpError && this.config.onHttpError(key, response.data, requestData, response)
            // this.dispatch(key, response.data, requestData, response, fullData)
            // this.dispatch(key, [], requestData, response)
        } catch (e) {
            console.debug('httpReponse error info', e)
        } finally {
            reject(new Error('http error'));
            this.finishAndCheck()
        }


    }

    httpRequestTimeout(promisePara, key, requestData, error, requestId,notifyFlag)
    {
        var {promise,resolve,reject} = promisePara;;
        try{

            this.config.onHttpTimeoutError && this.config.onHttpTimeoutError(key, data, error, requestId)

            // this.httpReponse(key, data, error, requestId)

        } catch (e) {
            console.debug('httpReponse timeout handle err info', e)
        } finally {
            reject(new Error('http request time out'));
            this.finishAndCheck()
        }
    }

    websocketOpen(evt) {
        this.websocketConnecting = false
        this.websocketConnected = true
        //如果配置了 socket 连接成功的messageKey 则发送通知
        console.debug('====websocketOpen======')
        this.config.websocketOnOpenMessageKey && this.dispatch(this.config.websocketOnOpenMessageKey, null)
        //调用socket打开方法
        this.onSocketOpen && this.onSocketOpen()
        this.finishAndCheck()
    }

    closeWebSocket() {
        this.websocketConnected && this.websocket &&  this.websocket.close();
    }

    websocketClose(evt) {
        console.debug('====websocketClose======')
        global.__DEBUG__ && alert('====websocketClose======')
        this.websocketConnected = false
        if (this.config.websocketOnCloseMessageKey)
            this.dispatch(this.config.websocketOnCloseMessageKey, null)
        this.onSocketClose && this.onSocketClose()
        this.finishAndCheck()
        //alert('长时间未操作，请刷新页面')
        //window.location.reload(true)
    }

    websocketMessage(evt) {
        // var tag = this.config.socketOperateId;
        var data = null
        if (evt.data && typeof evt.data === 'string') {
            try {
                data = JSON.parse(evt.data)
            } catch (e) {
                data = evt.data
            }
        }
        if (data === null) {
            //流格式数据？暂时不处理
            return;
        }

        this.onSocketMessage && this.onSocketMessage(data)
        this.finishAndCheck()
    }

    websocketError(evt) {
        console.debug('====websocketError======')
        this.websocketConnected = false
        //声明websocket连接默认为 false
        this.websocketConnecting = false
        if (this.config.websocketOnErrorMessageKey)
            this.dispatch(this.config.websocketOnErrorMessageKey, null)

        this.onSocketError && this.onSocketError()

        this.finishAndCheck()
        //alert('长时间未操作，请刷新页面')
        //window.location.reload(true)
    }



}
